import React, { useState } from 'react'
import PantryItemCard from '../components/PantryItemCard'

export default function Pantry() {
    const pantryItems = [
        {
            name: "Tuna",
            qty: "3 cans",
            img: "https://starkist.com/sites/default/files/products/3307_Can-in-water-%26-Oil-chunk-light-water_0.png"
        },
        {
            name: "Carrots",
            qty: "1 lb",
            img: "https://image.shutterstock.com/image-vector/carrot-260nw-288549701.jpg"
        },
        {
            name: "Broccoli",
            qty: "0.2 lbs",
            img: "https://www.edamam.com/web-img/88d/88d23618c19c48e5fdc03c561eee5fe9.jpg"
        },
        {
            name: "Wagyu Beef",
            qty: "6 oz",
            img: "https://d2imri64gxn369.cloudfront.net/media/catalog/product/cache/1/image/420x/17f82f742ffe127f42dca9de82fb58b1/d/b/dbsb0144_dsc05881.jpg"
        },
        {
            name: "Chicken Breast",
            qty: "12 oz",
            img: "https://bmexdi064h-flywheel.netdna-ssl.com/wp-content/uploads/2018/08/Instant-Pot-Chicken-Breasts-foodiecrush.com-006A.jpg"
        },
        {
            name: "White Rice",
            qty: "3 lbs",
            img: "https://cdnimg.webstaurantstore.com/images/products/large/230949/1136757.jpg"
        }
    ]
    
    return (
        <div className='Pantry'>
            { pantryItems.map( item => <PantryItemCard img={item.img} title={item.name} qty={item.qty}/>) }
        </div>
    )
}
